// extracted by mini-css-extract-plugin
module.exports = {"loaderCircular":"Loader_loaderCircular___u1L8","spin":"Loader_spin__jcD5s","loader_progress":"Loader_loader_progress__dBTBj"};